import React from 'react';
import { Container, Row, Col, Tab, Nav } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/faq.js';
import useSiteContent from '../../hooks/useSiteContent';

const Faq = () => {
    const { categories = [] } = useSiteContent("faq");

    return (
        <Styles>
            {/* Main Wrapper */}
            <div className="main-wrapper faq-page">

                {/* Header 2 */}
                <HeaderTwo />

                {/* Breadcroumb */}
                <BreadcrumbBox title="Faq" />

                {/* Faq Area */}
                <section className="faq-area">
                    <Container>
                        <Row>
                            <Col md="12">
                                {categories.length > 0 && (
                                    <Tab.Container defaultActiveKey={categories[0].key}>
                                        <Nav className="justify-content-center">
                                            {categories.map((category) => (
                                                <Nav.Item key={category.key}><Nav.Link eventKey={category.key}>{category.title}</Nav.Link></Nav.Item>
                                            ))}
                                        </Nav>
                                        <Tab.Content>
                                            {categories.map((category) => (
                                                <Tab.Pane eventKey={category.key} key={category.key}>
                                                    <Row>
                                                        {
                                                            (category.items || []).map((data, i) => (
                                                                <Col md="6" key={i}>
                                                                    <div className="faq-item">
                                                                        <div className="faq-title d-flex">
                                                                            <div className="title-icon"><span>Q</span></div>
                                                                            <div className="title-text"><p>{data.question}</p></div>
                                                                        </div>
                                                                        <div className="faq-desc">
                                                                            <p>{data.answer}</p>
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            ))
                                                        }
                                                    </Row>
                                                </Tab.Pane>
                                            ))}
                                        </Tab.Content>
                                    </Tab.Container>
                                )}
                            </Col>
                        </Row>
                    </Container>
                </section>

                {/* Footer 2 */}
                <FooterTwo />

            </div>
        </Styles>
    )
}

export default Faq
